// 🔧 categories_and_entries.js
// ✅ Purpose: Public-facing manager guide for categories and entries
// ✅ Features:
// - Explains how categories organize voting
// - Explains how entries are added and approved
// - Public and SEO-friendly
// - Uses the Dashboard-style LGV layout
// - Fully block-commented for clarity and future devs

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../../components/seo_head";

function CategoriesAndEntriesGuide() {
  return (
    <section id="top-content" className="container-fluid py-5">
      <SeoHead
        title="Categories and Entries Guide | Let's Go Vote"
        description="Learn how to organize event categories, add entries, manage public submissions, and prepare entries for voting in Let's Go Vote."
        path="/guides/categories-and-entries"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Guides", path: "/guides" },
          {
            name: "Categories & Entries",
            path: "/guides/categories-and-entries",
          },
        ]}
      />
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5">🚗 Categories & Entries</h1>
          <p className="lead text-muted">
            Organize what people vote on and prepare your event for voting.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white">
        <section className="mb-5">
          <div className="alert alert-info text-start">
            <h5 className="mb-3">Categories keep voting organized</h5>
            <p className="mb-0">
              Categories are the groups voters choose from. Entries are the
              people, vehicles, pets, artwork, candidates, or items inside those
              categories.
            </p>
          </div>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 1: Create your categories</h3>
          <p>
            Add categories that match your event. For a car show, this might be
            Stock, Custom, Convertible, and Best in Show. For an art show, this
            might be Painting, Sculpture, Photography, and Youth Art.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 2: Add entries</h3>
          <p>
            Entries can include names, descriptions, registration numbers,
            photos, and other details that help voters understand what they are
            voting on.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 3: Review public submissions</h3>
          <p>
            If public entry submissions are enabled, participants can submit
            their own entries. Managers can review and approve entries before
            they become visible to voters.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 4: Check entry visibility</h3>
          <p>
            Before event day, review your public entries page and make sure each
            approved entry appears correctly with the right category, title,
            description, and images.
          </p>
        </section>

        <section className="mb-0">
          <div className="alert alert-primary text-start mb-0">
            <h5 className="mb-3">Next recommended guide</h5>
            <p className="mb-3">
              After categories and entries are ready, prepare QR codes for event
              day.
            </p>

            <Link to="/guides/qr-codes" className="btn btn-primary">
              Continue to QR Codes
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}

export default CategoriesAndEntriesGuide;